"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderContext = void 0;
const React = require("react");
/**
 * Provides a sales order that holds the data for a pending order.
 */
exports.SalesOrderContext = React.createContext({
    temporarySalesOrderId: undefined,
    salesOrderItems: undefined,
    totalPrice: undefined,
    promotions: undefined,
    processSalesOrderError: undefined,
    retrieveTemporarySalesOrderError: undefined,
    setTemporarySalesOrderError: undefined,
    isRetrievingTemporarySalesOrder: undefined,
    isSettingTemporarySalesOrder: undefined,
    isPerformingCartRecovery: undefined,
    setIsPerformingCartRecovery: undefined,
    resetCart: undefined,
    populateCart: undefined,
    getSavedTemporarySalesOrderId: undefined,
    addSalesOrderItemToSalesOrder: undefined,
    updateSalesOrderItemBuilt: undefined,
    updateSalesOrderItemQuantity: undefined,
    removeSalesOrderItemFromSalesOrder: undefined,
    processSalesOrder: undefined,
    validateSalesOrder: undefined,
    isReorder: undefined,
    setIsReorder: undefined,
    isUpdatingCart: undefined,
    hasSalesOrderError: undefined,
    setHasSalesOrderError: undefined,
    cartNoLongerExists: undefined,
    setCartNoLongerExists: undefined,
    requestedReadyTime: undefined,
    setRequestedReadyTime: undefined,
    notes: undefined,
    setNotes: undefined,
    processingOrder: undefined,
    totalItems: undefined,
    hasCart: undefined,
    finishedUpdatingCart: undefined,
    temporaryAddress: undefined,
    setTemporaryAddress: undefined
});
//# sourceMappingURL=index.js.map